import type { UseResponseDialogProps } from './types';

import { useContext } from 'react';

import { ResponseDialogContext } from '@/components/common/response-dialog';

export const useResponseDialog = (props: UseResponseDialogProps = {}) => {
  const context = useContext(ResponseDialogContext);
  if (!context) {
    throw new Error('useResponseDialog must be used within ResponseDialogProvider');
  }

  const defaultRemoveDialog = context.removeDialog;
  const callback = props.removeDialogCallback;

  if (callback) {
    context.removeDialog = () => {
      defaultRemoveDialog();
      callback(context.dialogs);
    };
  }

  return context;
};
